import request from '@/utils/request';

export default {
  // 获取访客列表
  getVisitorList: data =>
    request(`/core/vm/visitor/list/${data.current}/${data.pageSize}`, {
      method: 'post',
      body: data.condition,
    }),
  // 批量删除访客列表
  deleteAll: data =>
    request(`/core/vm/visitor/deleteAll`, {
      method: 'post',
      body: data,
    }),
  // 消息推送
  visitorMsg: (type, key) =>
    request(`/core/vm/visitor/msg/${type}/${key}`, {
      method: 'post',
    }),
  // 新增
  visitorSave: data =>
    request(`/core/vm/visitor/save`, {
      method: 'post',
      body: data,
    }),
  // 修改
  visitorUpdate: data =>
    request(`/core/vm/visitor/update`, {
      method: 'post',
      body: data,
    }),
  // 详情
  getVisitorObj: appointId =>
    request(`/core/vm/visitor/${appointId}`, {
      method: 'get',
    }),
  // 删除
  visitorDelete: appointId =>
    request(`/core/vm/visitor/${appointId}`, {
      method: 'DELETE',
    }),
  // 邀约消息推送
  visitorInner: data =>
    request(`/core/vm/visitor/inner/save`, {
      method: 'post',
      body: data,
    }),
  // 获取访客邀约信息
  visitorApply: key =>
    request(`/core/vm/visitor/apply/${key}`, {
      method: 'get',
    }),
  // 一体机保存接口
  aioRegister: (data, headers) =>
    request(`/core/open/device/aio/register`, {
      method: 'post',
      body: data,
      headers: headers,
    }),
};
